// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3495":"f7653ca9","4449":"c8f21f43","7049":"2308d010","9628":"5c0f1342"}[chunkId] + ".chunk.css";
};